module.exports = __webpack_public_path__ + "static/img/img-5-1.7c56e30.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-5-1.png
// module id = 1UPz
// module chunks = 0